import { DialogTitle, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { TextSpan } from '../../../Atoms/Text';

interface SubtitledDialogTitleProps {
  title: string;
  subtitle: string;
  // While a call is in flight, so the dialog can't be closed under it.
  busy: boolean;
  onClose: () => void;
}

export const SubtitledDialogTitle = ({ title, subtitle, busy, onClose }: SubtitledDialogTitleProps) => (
  <DialogTitle className="flex items-start justify-between">
    <span>
      {title}
      <TextSpan
        className="block"
        size="sm"
        color="grey6">
        {subtitle}
      </TextSpan>
    </span>
    <IconButton
      aria-label="Close"
      size="small"
      disabled={busy}
      onClick={onClose}>
      <CloseIcon fontSize="small" />
    </IconButton>
  </DialogTitle>
);
